export default {
    UPDATE_USERS_REQUEST: 'USER_LIST_UPDATE_USERS_REQUEST',
    UPDATE_USERS_SUCCESS: 'USER_LIST_UPDATE_USERS_SUCCESS',

    CACHE_BULK_UPDATE_USERS: 'USER_LIST_CACHE_BULK_UPDATE_USERS',
    BULK_ACTIVATE_USERS_REQUEST: 'USER_LIST_BULK_ACTIVATE_USERS_REQUEST',
    BULK_ACTIVATE_USERS_SUCCESS: 'USER_LIST_BULK_ACTIVATE_USERS_SUCCESS',

    BULK_DELETE_OR_ARCHIVE_USERS_REQUEST: 'USER_LIST_BULK_DELETE_OR_ARCHIVE_USERS_REQUEST',
    BULK_DELETE_OR_ARCHIVE_USERS_SUCCESS: 'USER_LIST_BULK_DELETE_OR_ARCHIVE_USERS_SUCCESS',

    DISPOSE: 'USER_LIST_DISPOSE_STORE',
    REMOVE_USER_FROM_CACHED_USERS: 'USER_LIST_REMOVE_USER_FROM_CACHED_USERS',
};
